module.exports = __webpack_public_path__ + "img/boxed-9.092b9c9f.jpg";